import React, { Component } from "react";
import PropTypes from "prop-types";

import PersonalityModal from "./PersonalityModal";

const propTypes = {
  text: PropTypes.string,
  personality: PropTypes.object.isRequired
};

class PersonalityModalButton extends Component {
  constructor() {
    super();
    this.state = {
      showModal: false
    };
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  handleOpenModal() {
    this.setState({ showModal: true });
  }

  handleCloseModal() {
    this.setState({ showModal: false });
  }

  render() {
    return (
      <div>
        <button className="button automargin" onClick={this.handleOpenModal}>
          {this.props.text}
        </button>
        <PersonalityModal
          isOpen={this.state.showModal}
          onRequestClose={this.handleCloseModal}
          personality={this.props.personality}
        />
      </div>
    );
  }
}

PersonalityModalButton.propTypes = propTypes;

export default PersonalityModalButton;
